import {
  GoogleAuthProvider,
  browserLocalPersistence,
  onAuthStateChanged,
  setPersistence,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { auth } from '@/firebase';

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

function serializeUser(user) {
  if (!user) return null;

  return {
    uid: user.uid,
    displayName: user.displayName,
    email: user.email,
    emailVerified: user.emailVerified,
    photoURL: user.photoURL,
  };
}

function getAuthErrorMessage(error) {
  const messages = {
    'auth/account-exists-with-different-credential': 'An account already exists with this email using a different sign-in method.',
    'auth/network-request-failed': 'Google sign-in could not reach the network. Check your connection and try again.',
    'auth/operation-not-allowed': 'Google sign-in has not been enabled for this site yet.',
    'auth/popup-blocked': 'Your browser blocked the Google sign-in window. Allow popups for this site and try again.',
    'auth/popup-closed-by-user': 'The Google sign-in window was closed before sign-in finished.',
    'auth/unauthorized-domain': 'This domain has not been authorized for Google sign-in.',
  };

  return messages[error?.code] || 'Google sign-in did not complete. Please try again.';
}

async function signInWithGoogle() {
  await setPersistence(auth, browserLocalPersistence);
  return signInWithPopup(auth, googleProvider);
}

function signOutUser() {
  return signOut(auth);
}

function watchAuthState(onUserChanged, onError) {
  return onAuthStateChanged(
    auth,
    (user) => onUserChanged(serializeUser(user)),
    onError,
  );
}

export {
  getAuthErrorMessage,
  serializeUser,
  signInWithGoogle,
  signOutUser,
  watchAuthState,
};
